import { Box, Flex, Image } from '@chakra-ui/react';

import ImagePlaceholder from 'Asset/image/image-placeholder.svg';
import { AlertOutlineIcon, EditIcon } from 'Asset/icon';
import { Condition, Iteration } from 'Component/others';
import { TextBold, TextRegular, TextSemiBold } from 'UiKit/typography';
import ButtonOutline from 'UiKit/button/buttonOutline';
import formatCurrency from 'Helper/formatCurrency';
import PurchaseProductCard from 'View/brief-live/component/purchase-product-card';

import styles from './styles.module.css';

const GiveawayViewItem = ({ t, giveaway, onEdit }) => (
  <Box className={styles['container']}>
    <Flex width={'100%'} justifyContent={'space-between'} marginBottom={'26px'}>
      <TextBold className={styles['text--title']}>{t('formGiveaway.prizeInformation')}</TextBold>
      <ButtonOutline borderWidth="1.5px" width="32px" height="32px" onClick={onEdit}>
        <EditIcon color="var(--color-info70)" size="16px" />
      </ButtonOutline>
    </Flex>
    <Box className={styles['box--product']}>
      <Image src={giveaway?.imagePath} fallbackSrc={ImagePlaceholder} width={'45px'} height={'45px'} alt={giveaway?.productName} borderRadius={'4px'} />
      <Box>
        <TextBold className={styles['text--product-name']}>{giveaway?.productName}</TextBold>
        <Flex gap={'24px'}>
          <TextRegular className={styles['text--total-stock-label']}>{t('formGiveaway.totalStock')}</TextRegular>
          <TextSemiBold className={styles['text--total-stock-value']}>{giveaway?.totalStock}</TextSemiBold>
        </Flex>
      </Box>
    </Box>
    <Flex width={'100%'}>
      <Box className={styles['box--requirement']}>
        <TextBold className={styles['text--head-title']}>{t('formGiveaway.requirement')}</TextBold>
        <Condition statement={giveaway?.rules?.note}>
          <Flex gap={'6px'} alignItems={'start'} marginBottom={'20px'}>
            <AlertOutlineIcon size="14px" color="var(--color-primary70)" />
            <TextRegular className={styles['text--rule-notes']}>{giveaway?.rules?.note}</TextRegular>
          </Flex>
        </Condition>
        <Condition
          statement={giveaway?.rules?.type === 'MINIMUM_PURCHASE'}
          fallback={
            <>
              <Box>
                <TextRegular className={styles['text--min-purchase']}>{t('formGiveaway.productPurchase')}</TextRegular>
              </Box>
              <Iteration
                items={giveaway?.rules?.requiredProducts}
                render={(item, index, array) => <PurchaseProductCard item={item} isLast={index === array.length - 1} />}
              />
            </>
          }
        >
          <Flex flexDirection={'column'} gap={'8px'} marginBottom={'20px'}>
            <TextRegular className={styles['text--min-purchase']}>{t('formGiveaway.minimumSpend')}</TextRegular>
            <TextBold className={styles['text--min-purchase-value']}>{formatCurrency(giveaway?.rules?.minimumPurchaseAmount)}</TextBold>
          </Flex>
          <Condition statement={giveaway?.rules?.requiredProducts?.length}>
            <Box>
              <TextRegular className={styles['text--min-purchase']}>{t('formGiveaway.withProductPurchase')}</TextRegular>
            </Box>
            <Iteration
              items={giveaway?.rules?.requiredProducts}
              render={(item, index, array) => <PurchaseProductCard item={item} isLast={index === array.length - 1} />}
            />
          </Condition>
        </Condition>
      </Box>
      <Box className={styles['box--duration']}>
        <TextBold className={styles['text--head-title']}>{t('formGiveaway.giveawayDuration')}</TextBold>
        <Iteration
          items={giveaway?.sessions}
          render={(session, index, array) => (
            <Box
              key={index}
              className={styles['box--session-item']}
              paddingBottom={index === array.length - 1 ? '0' : '20px'}
              paddingTop={'20px'}
              borderBottom={index === array.length - 1 ? 'none' : '0.5px solid var(--color-semantic-outline)'}
            >
              <Flex className={styles['box--session-field']}>
                <Box flex={2}>
                  <TextRegular className={styles['text--session-label']}>{t('formGiveaway.platform')}</TextRegular>
                </Box>
                <Box flex={6}>
                  <TextSemiBold className={styles['text--session-value']}>{session?.accountLivestream?.name || '-'}</TextSemiBold>
                </Box>
              </Flex>
              <Flex className={styles['box--session-field']}>
                <Box flex={2}>
                  <TextRegular className={styles['text--session-label']}>{t('formGiveaway.allocation')}</TextRegular>
                </Box>
                <Box flex={6}>
                  <TextSemiBold className={styles['text--session-value']}>{session?.allocatedStock}</TextSemiBold>
                </Box>
              </Flex>
              <Flex className={styles['box--session-field']}>
                <Box flex={2}>
                  <TextRegular className={styles['text--session-label']}>{t('formGiveaway.displayTime')}</TextRegular>
                </Box>
                <Box flex={6}>
                  <TextSemiBold className={styles['text--session-value']}>
                    <span style={{ marginRight: '10px' }}>{session?.promotionDate}</span>
                    <span>{session?.showTime}</span>
                  </TextSemiBold>
                </Box>
              </Flex>
            </Box>
          )}
        />
      </Box>
    </Flex>
  </Box>
);

export default GiveawayViewItem;
